import { IconButton, BackIcon as backIcon, NextArrowIcon as nextIcon } from '@/shared/ui';
import useNavigatorContainer from './useNavigatorContainer';

export type NavigatorContainerProps = {
  startReport: any;
  stopReport: any;
  timezoneOffset: number;
  displayedBeatId: any;
  disabledNoDataRange: { isDisabledPrev: boolean; isDisabledNext: boolean };
  navigateStrip: (isNext?: boolean) => void;
};

/**
 * Renders the previous and next 10-second navigation bar above the beat ECG viewer. Disables each button from the hook's edge flags, calls navigateStrip with no argument to step back and with true to step forward, and prints the selected strip's date with its start and end times, or a dash when no beat is displayed.
 *
 * @param props - Navigator props with the displayed beat id and the navigateStrip callback.
 * @returns The rendered strip navigation bar.
 */
const NavigatorContainer = ({
  startReport,
  stopReport,
  timezoneOffset,
  displayedBeatId,
  disabledNoDataRange,
  navigateStrip,
}: NavigatorContainerProps) => {
  const {
    isDisabledPrevious,
    isDisabledNext,
    selectedStripMoment,
    selectedStripSubtractMoment,
    selectedStripAddMoment,
  } = useNavigatorContainer({
    startReport,
    stopReport,
    timezoneOffset,
    displayedBeatId,
    disabledNoDataRange,
    navigateStrip,
  });

  return (
    <div className="navigator-container">
      <IconButton
        id="beats-rr-nav-prev-10s-btn"
        iconComponent={<img src={backIcon} alt="Back icon" />}
        isFilledIconWithText
        iconText="Previous 10s"
        disabled={isDisabledPrevious}
        onClick={() => {
          navigateStrip();
        }}
      />
      <div className="strip-info">
        {displayedBeatId
          ? `${selectedStripMoment.format('MM/DD/YYYY')}, ${selectedStripSubtractMoment.format('HH:mm:ss')} - ${selectedStripAddMoment.format('HH:mm:ss')}`
          : '--'}
      </div>
      <IconButton
        id="beats-rr-nav-next-10s-btn"
        iconComponent={<img src={nextIcon} alt="Next icon" />}
        isFilledIconWithText
        iconText="Next 10s"
        isOpposite
        disabled={isDisabledNext}
        onClick={() => {
          navigateStrip(true);
        }}
      />
    </div>
  );
};

export default NavigatorContainer;
